import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { auth, signOut } from "../firebase/firebaseApp";
import Logo from "../assets/prairiwhite.png";
import PrairiTextLogo from "../assets/prairitext.png";
import SilverLogo from "../assets/silver-unicorn.png";
import SilverPrairiTextLogo from "../assets/silver-prairi.png";
import { VscMenu } from "react-icons/vsc";
import { CgClose } from "react-icons/cg";
import { BiLogIn } from "react-icons/bi";
import {
  authContext,
  dataContext,
  investorContext,
  navBarContext,
} from "./context/context";
import { query, collection, db, where, getDocs } from "../firebase/firebaseApp";
import { mergeRefs } from "react-merge-refs";
import useMeasure from "react-use-measure";
import { useMediaQuery } from "react-responsive";
import {
  LogoutConfirmation,
  Modal,
  MessageSlider,
} from "@peterfosso/prairi-components";
import Rocket from "../assets/stage.gif";
import Header1 from "../assets/header1.png";
import Header2 from "../assets/header2.png";
import Header3 from "../assets/header3.png";
import Header4 from "../assets/header4.png";
import HeaderPiece from "../assets/header-piece.png";
import HeaderPieceMobile from "../assets/short-header.png";

const NavBar = React.forwardRef((props, ref) => {
  const { onResetDashboard } = props;
  const location = useLocation();
  const isRegister =
    /^\/register\/[a-zA-Z0-9]*$/.test(location.pathname) ||
    /^\/create\/[a-zA-Z0-9]*$/.test(location.pathname);

  const isLandingPage =
    /^\/invitation\/[a-zA-Z0-9]*$/.test(location.pathname) ||
    location.pathname === "/" ||
    location.pathname === "/landing" ||
    location.pathname === "/startups/howitworks";
  const isAd = location.pathname === "/startups/howitworks";

  const data = useContext(dataContext);
  const investorData = useContext(investorContext);
  const isMobile = useMediaQuery({ maxWidth: 800 });
  // which context to use?
  const contextData = data.globalData
    ? data
    : investorData.globalData
    ? investorData
    : null;

  const sliderMessages = [
    <div>
      <span className="font-bold mr-1">New Feature! </span> Pitch decks display
      automatically to investors on a PC/laptop
    </div>,
    <div className="flex">
      <img alt="rocket icon" src={Rocket} className="w-[20px] h-[20px] mr-2" />{" "}
      New! Check out our new{" "}
      <span className="font-bold mx-1">deal tracking</span> feature!
    </div>,
  ];
  const sliderColors = ["#204549"];

  const isInvitationForm =
    location.pathname === "/invitation/investor" ||
    location.pathname === "/invitation/startup";
  const isDashboard = location.pathname === "/dashboard";
  const isSettings =
    location.pathname === "/settings" ||
    location.pathname === "/dataprofile/investor" ||
    location.pathname === "/dataprofile/startup" ||
    location.pathname === "/investorregistration" ||
    location.pathname === "/startupregistration" ||
    location.pathname === "/forgotpassword" ||
    location.pathname === "/matchpause" ||
    location.pathname === "/remove";

  const noNav =
    (/^\/notifications\/[a-zA-Z0-9]+$/i.test(location.pathname) && isMobile) ||
    (location.pathname === "/thatsall" && isMobile) ||
    (/\/join\/[a-zA-Z0-9_]+/.test(location.pathname) && isMobile) ||
    location.pathname === "/investorhome" ||
    /^\/invited\/[a-zA-Z0-9]*$/.test(location.pathname);

  const hasSlider =
    location.pathname === "/getfunded" || //turns out this is also used for the header (Prairie)
    location.pathname === "/discover" ||
    /^\/discover\/[a-zA-Z0-9]+$/i.test(location.pathname) ||
    /^\/getfunded\/[a-zA-Z0-9]*$/.test(location.pathname);

  const noNavDesk =
    /^\/notifications\/[a-zA-Z0-9]+$/i.test(location.pathname) ||
    location.pathname === "/thatsall" ||
    /\/join\/[a-zA-Z0-9_]+/.test(location.pathname) ||
    location.pathname === "/getfunded";

  //console.log("is new match" + JSON.stringify(isNewMatch))
  const { currentUser } = useContext(authContext);
  const [userData, setUserData] = useState("");
  const [logoutPopup, setLogoutPopup] = useState(false);
  const [isAdmin, setIsAdmin] = useState(null);
  const [isPaused, setIsPaused] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [sliderOpen, setSliderOpen] = useState(true);
  const [navBarRef, { height }] = useMeasure();
  const [selectedMenuItem, setSelectedMenuItem] = useState("Home");
  const [showPricingDropdown, setShowPricingDropdown] = useState(false);
  const pricingRefDesktop = useRef(null);
  const pricingRefMobile = useRef(null);
  const closeTimerRef = useRef(null);

  let navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await signOut(auth);
      setLogoutPopup(false);
      navigate("/");
      setSelectedMenuItem("home");
    } catch (error) {
      // console.log(error);
    }
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const getDataFromDb = async () => {
    try {
      // Get user data from email
      const email = currentUser?.email;
      const q = query(collection(db, "users"), where("email", "==", email));
      const querySnapshot = await getDocs(q);
      let userData;
      let userId;
      querySnapshot.forEach((doc) => {
        userData = doc.data();
        userId = doc.id;
      });
      if (userId === "gr21pGWNxWYptQIpEJmE") {
        setIsAdmin(true);
      }

      return { userData, userId };
    } catch (error) {
      // console.log(error);
      return { userData: null };
    }
  };

  useEffect(() => {
    if (isDashboard) {
      setSelectedMenuItem("My Dashboard");
    } else if (isLandingPage) {
      setSelectedMenuItem("Home");
    } else if (isSettings) {
      setSelectedMenuItem("Settings");
    }
  }, [isDashboard, isLandingPage, isSettings, noNav]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { userData } = await getDataFromDb();
        setUserData(userData);
        if (userData.paused) {
          setIsPaused(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentUser]);

  const handleRefreshDashboard = () => {
    window.location.reload();
    console.log("refresh");
  };

  useEffect(() => {
    // Hide the options when the page changes
    setShowMenu(false);
  }, [location]);

  useEffect(() => {
    const updateNavHeight = () => {
      props.updatedNavBarHeight(height);
    };
    updateNavHeight();
  }, [height, props]);

  const handleMouseEnter = () => {
    setShowPricingDropdown(true);
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const handleMouseLeave = () => {
    closeTimerRef.current = setTimeout(() => {
      setShowPricingDropdown(false);
    }, 500);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pricingRefDesktop.current &&
        !pricingRefDesktop.current.contains(event.target) &&
        pricingRefMobile.current &&
        !pricingRefMobile.current.contains(event.target)
      ) {
        setShowPricingDropdown(false);
        if (closeTimerRef.current) {
          clearTimeout(closeTimerRef.current);
          closeTimerRef.current = null;
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) {
        clearTimeout(closeTimerRef.current);
      }
    };
  }, []);

  return (
    <>
      {noNav && null}
      {currentUser ? (
        // Current User Cases
        <>
          {isLandingPage ? (
            // Current User + Landing Page
            <div
              style={{
                position: "fixed",
                top: "10",
                left: "0",
                right: "0",
                width: "100%",
                zIndex: "99999",
              }}
              ref={mergeRefs([ref, navBarRef])}
              className={`${sliderOpen?"px-0":"py-2 px-4"}fixed top-0 left-0 right-0 w-full z-99999 from-navStart to-navEnd shadow-lg text-[#f2f2f2] shadow-black/60  max-w-screen max-w-[100vw]`}
            >
              {sliderOpen && (
                <div className="h-[32px] flex items-center overflow-hidden">
                  <MessageSlider
                    colors={sliderColors}
                    messages={sliderMessages}
                    interval={4000}
                    onClose={() => setSliderOpen(false)}
                  />
                </div>
              )}
              <div className="">
                <nav className=" w-full flex justify-between items-center lg:px-20 z-1 relative">
                  <Link
                    className="flex lg:justify-center items-center"
                    to="/landing"
                  >
                    <img
                      className="h-8 md:h-14  mr-3 transition-all duration-500 ease-in-out delay-75"
                      src={Logo}
                      alt="Prairi"
                    />
                    <div className="w-20 lg:w-32">
                      <img
                        className="w-full"
                        src={PrairiTextLogo}
                        alt="Prairi Text"
                      />
                    </div>
                  </Link>
                  <div className="text-[#c8c8c8]">
                    {showMenu ? (
                      <div className="flex">
                        <button onClick={toggleMenu} className="lg:hidden mx-4">
                          <CgClose className="text-2xl" />
                        </button>
                      </div>
                    ) : (
                      <div className="flex justify-end font-semibold h-full">
                        <button onClick={toggleMenu} className="lg:hidden">
                          <VscMenu className="text-2xl ml-4 mr-4" />
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="hidden lg:flex md:flex-row items-center">
                    {isAdmin && (
                      <Link
                        to="/admindashboard"
                        className={`font-bold text-sm md:text-base md:mr-4 ${
                          selectedMenuItem === "Admin"
                            ? "text-white"
                            : "text-white"
                        }`}
                      >
                        Admin
                      </Link>
                    )}
                    {!isDashboard && (
                      <Link
                        to="/dashboard"
                        className={`font-bold text-sm md:text-base md:mr-4 ${
                          selectedMenuItem === "My Dashboard"
                            ? "text-white"
                            : "text-white"
                        }`}
                      >
                        My Dashboard
                      </Link>
                    )}
                    {isDashboard && (
                      <div
                        className={`font-bold text-sm md:text-base md:mr-4 cursor-pointer ${
                          selectedMenuItem === "My Dashboard"
                            ? "text-white"
                            : "text-white"
                        }`}
                        onClick={onResetDashboard}
                      >
                        My Dashboard
                      </div>
                    )}
                    {!isPaused && (
                      <Link
                        to="/settings"
                        className={`font-bold text-sm md:text-base mr-2 md:mr-4 ${
                          selectedMenuItem === "Settings"
                            ? "text-white"
                            : "text-white"
                        }`}
                      >
                        Settings
                      </Link>
                    )}
                  </div>
                </nav>
                {showMenu && (
                  <div className="w-full mx-auto my-4 text-center text-sm md:text-base lg:hidden">
                    {!isRegister && (
                      <div className="flex  justify-between">
                        {!isDashboard && (
                          <Link
                            to="/dashboard"
                            className={`font-bold text-sm md:text-base mr-2 md:mr-4 text-white`}
                          >
                            My Dashboard
                          </Link>
                        )}
                        {isDashboard && (
                          <div
                            className={`font-bold text-sm md:text-base md:mr-4 cursor-pointer text-white`}
                            onClick={onResetDashboard}
                          >
                            My Dashboard
                          </div>
                        )}
                        {!isPaused && (
                          <Link
                            to="/settings"
                            className={`font-bold text-sm md:text-base mr-2 md:mr-4 text-white`}
                          >
                            Settings
                          </Link>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            // Current User + Not Landing Page
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                width: "100%",
                zIndex: "99999",
              }}
              ref={mergeRefs([ref, navBarRef])}
              className={`bg-black shadow-lg text-[#f2f2f2] shadow-black/60 ${
                hasSlider ? "px-0" : "py-2 px-4"
              }`}
            >
              {hasSlider && sliderOpen && (
                <div className="h-[32px] flex items-center overflow-hidden">
                  <MessageSlider
                    colors={sliderColors}
                    messages={sliderMessages}
                    interval={4000}
                    onClose={() => setSliderOpen(false)}
                  />
                </div>
              )}
              <div className="bg-black">
                <nav
                  className={`w-full flex justify-between items-center ${
                    hasSlider ? "" : "lg:px-20"
                  } ${hasSlider ? "py-4" : "py-2"}`}
                >
                  {hasSlider && (
                    <div className="w-[50%] flex items-center">

                        <img
                          src={isMobile?HeaderPieceMobile:HeaderPiece}
                          alt="Prairi"
                          className="w-full h-auto transition-all duration-500 ease-in-out delay-75 object-contain"
                        />
                      
                    </div>
                  )}
                  {!hasSlider && (
                    <Link
                      className="flex lg:justify-center items-center"
                      to="/"
                    >
                      <img
                        className="h-8 md:h-14 mr-3 transition-all duration-500 ease-in-out delay-75"
                        src={Logo}
                        alt="Prairi"
                      />
                      <div className="w-20 lg:w-32">
                        <img
                          className="w-full"
                          src={PrairiTextLogo}
                          alt="Prairi Text"
                        />
                      </div>
                    </Link>
                  )}
                  <div className="text-white flex justify-end h-full">
                    {showMenu ? (
                      <button onClick={toggleMenu} className="lg:hidden">
                        <CgClose className="text-3xl" />
                      </button>
                    ) : (
                      <div className="flex items-center w-auto h-full">
                        {isMobile && selectedMenuItem === "My Dashboard" && (
                          <Link
                            className="w-auto mr-8 font-semibold"
                            to={`/dashboard`}
                          >
                            {selectedMenuItem}
                          </Link>
                        )}
                        {isMobile && selectedMenuItem === "Settings" && (
                          <Link
                            className="w-auto mr-8 font-semibold"
                            to={`/${selectedMenuItem}`}
                          >
                            {selectedMenuItem}
                          </Link>
                        )}
                        <button onClick={toggleMenu} className="lg:hidden">
                          <VscMenu className="text-xl mr-6" />
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="hidden lg:flex md:flex-row items-center">
                    {isAdmin && (
                      <Link
                        to="/admindashboard"
                        className={`font-bold text-sm md:text-base md:mr-4 ${
                          selectedMenuItem === "Admin"
                            ? "text-white"
                            : "text-white"
                        }`}
                      >
                        Admin
                      </Link>
                    )}
                    {!isDashboard && (
                      <Link
                        to="/dashboard"
                        className={`font-bold text-sm md:text-base mr-2 md:mr-4 ${
                          selectedMenuItem === "My Dashboard" && !noNavDesk
                            ? "text-white"
                            : "text-[#c8c8c8]"
                        }`}
                      >
                        My Dashboard
                      </Link>
                    )}
                    {isDashboard && (
                      <div
                        className={`font-bold text-sm md:text-base md:mr-4 cursor-pointer ${
                          selectedMenuItem === "My Dashboard"
                            ? "text-white"
                            : "text-white"
                        }`}
                        onClick={onResetDashboard}
                      >
                        My Dashboard
                      </div>
                    )}
                    {!isPaused && (
                      <Link
                        to="/settings"
                        className={`font-bold text-sm md:text-base mr-2 md:mr-4 ${
                          selectedMenuItem === "Settings"
                            ? "text-white"
                            : "text-[#c8c8c8]"
                        }`}
                      >
                        Settings
                      </Link>
                    )}
                  </div>
                </nav>
                {showMenu && (
                  <div className="w-full mx-auto my-4 text-center text-sm md:text-base lg:hidden">
                    {!isRegister && (
                      <div className="flex  justify-between">
                        {!isDashboard && (
                          <Link
                            to="/dashboard"
                            className={`font-bold text-sm md:text-base mr-2 md:mr-4 text-white`}
                          >
                            My Dashboard
                          </Link>
                        )}
                        {isDashboard && (
                          <div
                            className={`font-bold text-sm md:text-base md:mr-4 cursor-pointer text-white`}
                            onClick={onResetDashboard}
                          >
                            My Dashboard
                          </div>
                        )}
                        {!isPaused && (
                          <Link
                            to="/settings"
                            className={`font-bold text-sm md:text-base mr-2 md:mr-4 text-white`}
                          >
                            Settings
                          </Link>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        // No Current User Cases
        <>
          {isLandingPage ? (
            // No Current User + Landing Page
            <div
              style={{
                position: "fixed",
                top: "10",
                left: "0",
                right: "0",
                width: "100%",
                zIndex: "99999",
              }}
              ref={mergeRefs([ref, navBarRef])}
              className={`${sliderOpen?"px-0":"py-2 px-4"}fixed top-0 left-0 right-0 w-full z-99999 from-navStart to-navEnd shadow-lg text-[#f2f2f2] shadow-black/60  max-w-screen max-w-[100vw]`}
            >
              {sliderOpen && (
                <div className="h-[32px] flex items-center overflow-hidden">
                  <MessageSlider
                    colors={sliderColors}
                    messages={sliderMessages}
                    interval={4000}
                    onClose={() => setSliderOpen(false)}
                  />
                </div>
              )}
              <div className="">
                <nav className={`lg:px-20 w-full flex justify-between items-center  z-1 relative`}>
                  <Link className="flex lg:justify-center items-center" to="/">
                    <img
                      className="h-8 md:h-14 mr-3 transition-all duration-500 ease-in-out delay-75"
                      src={Logo}
                      alt="Prairi"
                    />
                    <div className="w-20 lg:w-32">
                      <img
                        className="w-full"
                        src={PrairiTextLogo}
                        alt="Prairi Text"
                      />
                    </div>
                  </Link>
                  <div className="text-[#c8c8c8]">
                    {showMenu ? (
                      <div className="flex">
                        <button onClick={toggleMenu} className="lg:hidden mx-4">
                          <CgClose className="text-2xl" />
                        </button>
                      </div>
                    ) : (
                      <div className="flex justify-end font-semibold h-full">
                        <button onClick={toggleMenu} className="lg:hidden">
                          <VscMenu className="text-2xl ml-4 mr-4" />
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="hidden lg:flex md:flex-row items-center">
                    {!currentUser && !isAd && !isRegister && (
                      <div className="flex">
                        <Link
                          to="/getfunded"
                          className="font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                        >
                          Startups
                        </Link>
                        <Link
                          to="/discover"
                          className="font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                        >
                          Investors
                        </Link>
                        <div
                          className="relative"
                          ref={pricingRefDesktop}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <div className="cursor-pointer font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white">
                            Pricing
                            {showPricingDropdown && (
                              <div className="absolute top-full left-0 mt-2 w-48 bg-black/40 border border-gray-700 rounded-md shadow-lg z-50">
                                <div className="py-2">
                                  <Link
                                    to="/invitation/startup/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Startups
                                  </Link>
                                  <Link
                                    to="/invitation/investor/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Investors
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <Link
                          to="/login"
                          className="font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                        >
                          Log in
                        </Link>
                      </div>
                    )}
                  </div>
                </nav>
                {showMenu && (
                  <div className="w-full mx-auto my-4 text-center text-sm md:text-base lg:hidden">
                    {!currentUser && !isRegister && (
                      <div className="flex justify-between w-[90%] ">
                        <div
                          onClick={() => navigate("/getfunded")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Startups
                        </div>
                        <div
                          onClick={() => navigate("/discover")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Investors
                        </div>
                        <div className="relative">
                          <div
                            className="cursor-pointer font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                            onClick={() =>
                              setShowPricingDropdown(!showPricingDropdown)
                            }
                          >
                            Pricing
                            {showPricingDropdown && (
                              <div className="absolute top-full left-0 mt-2 w-48 bg-black/50 border border-gray-700 rounded-md shadow-lg z-50">
                                <div className="py-2">
                                  <Link
                                    to="/invitation/startup/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Startups
                                  </Link>
                                  <Link
                                    to="/invitation/investor/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Investors
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          onClick={() => navigate("/login")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Log in
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            // No Current User + Not Landing Page
            <div
              style={{
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                width: "100%",
                zIndex: "99999",
              }}
              ref={mergeRefs([ref, navBarRef])}
              className={`bg-black shadow-lg text-[#f2f2f2] shadow-black/60 ${
                hasSlider ? "px-0" : "py-2 px-4"
              }`}
            >
              {hasSlider && sliderOpen && (
                <div className="h-[32px] flex items-center overflow-hidden">
                  <MessageSlider
                    colors={sliderColors}
                    messages={sliderMessages}
                    interval={4000}
                    onClose={() => setSliderOpen(false)}
                  />
                </div>
              )}
              <div className="bg-black">
                <nav
                  className={`w-full flex justify-between items-center ${
                    hasSlider ? "" : "lg:px-20"
                  } ${hasSlider ? "py-4" : "py-2"}`}
                >
                  {hasSlider && (
                    <div className={`flex items-center ${isMobile ? "w-[80%]" : "w-[50%]"}`}>

                        <img
                          src={isMobile?HeaderPieceMobile:HeaderPiece}
                          alt="Prairi"
                          className="w-full h-auto cursor-pointer transition-all duration-500 ease-in-out delay-75 object-contain"
                          onClick={() => navigate("/")}
                        />
                      
                    </div>
                  )}
                  {!hasSlider && (
                    <Link
                      className="flex lg:justify-center items-center"
                      to="/"
                    >
                      <img
                        className="h-8 md:h-14 mr-3 transition-all duration-500 ease-in-out delay-75"
                        src={Logo}
                        alt="Prairi"
                      />
                      <div className="w-20 lg:w-32">
                        <img
                          className="w-full"
                          src={PrairiTextLogo}
                          alt="Prairi Text"
                        />
                      </div>
                    </Link>
                  )}
                  <div className="text-white flex justify-end h-full">
                    {showMenu ? (
                      <button onClick={toggleMenu} className="lg:hidden">
                        <CgClose className="text-3xl" />
                      </button>
                    ) : (
                      <div className="flex items-center w-auto h-full">
                        <button onClick={toggleMenu} className="lg:hidden">
                          <VscMenu className="text-xl mr-6" />
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="hidden lg:flex md:flex-row items-center">
                    {!currentUser && !isRegister && (
                      <div className="flex">
                        <Link
                          to="/getfunded"
                          className="font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                        >
                          Startups
                        </Link>
                        <Link
                          to="/discover"
                          className="font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                        >
                          Investors
                        </Link>
                        <div
                          className="relative"
                          ref={pricingRefDesktop}
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <div className="cursor-pointer font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white">
                            Pricing
                            {showPricingDropdown && (
                              <div className="absolute top-full left-0 mt-2 w-48 bg-black/50 border border-gray-700 rounded-md shadow-lg z-50">
                                <div className="py-2">
                                  <Link
                                    to="/invitation/startup/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Startups
                                  </Link>
                                  <Link
                                    to="/invitation/investor/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Investors
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <Link
                          to="/login"
                          className="font-bold text-sm md:text-base flex justify-end mr-24 text-white"
                        >
                          Log in
                        </Link>
                      </div>
                    )}
                  </div>
                </nav>
                {showMenu && (
                  <div className="mx-auto my-4 text-center text-sm md:text-base lg:hidden">
                    {!currentUser && (
                      <div className="flex justify-between w-[90%] ">
                        <div
                          onClick={() => navigate("/getfunded")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Startups
                        </div>
                        <div
                          onClick={() => navigate("/discover")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Investors
                        </div>
                        <div className="relative">
                          <div
                            className="cursor-pointer font-bold text-sm md:text-base flex justify-end mr-2 md:mr-4 text-white"
                            onClick={() =>
                              setShowPricingDropdown(!showPricingDropdown)
                            }
                          >
                            Pricing
                            {showPricingDropdown && (
                              <div className="absolute top-full left-0 mt-2 w-48 bg-black/50 border border-gray-700 rounded-md shadow-lg z-50">
                                <div className="py-2">
                                  <Link
                                    to="/invitation/startup/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Startups
                                  </Link>
                                  <Link
                                    to="/invitation/investor/stripe"
                                    className="block px-4 py-2 text-sm text-white/50 hover:text-white hover:bg-gray-800/50"
                                    onClick={() =>
                                      setShowPricingDropdown(false)
                                    }
                                  >
                                    For Investors
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          onClick={() => navigate("/login")}
                          className="font-bold text-sm cursor-pointer md:text-base text-white"
                        >
                          Log in
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <Modal open={logoutPopup} size="md">
        <LogoutConfirmation
          stay={() => setLogoutPopup(false)}
          logout={handleLogout}
        />
      </Modal>
    </>
  );
});

export default NavBar;